'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var type = require('./type.js');

const formatData = (contentType, values) => {
  let data = values || {};
  if (contentType === type.ContentType.formData) {
    data = new FormData();
    Object.entries(values).forEach(([key, value]) => {
      data.append(key, value);
    });
  } else if (contentType === type.ContentType.urlEncoded) {
    const body = [];
    Object.entries(values).forEach(([key, value]) => {
      const encodedKey = encodeURIComponent(key);
      const encodedValue = encodeURIComponent(
        value
      );
      body.push(`${encodedKey}=${encodedValue}`);
    });
    data = body.join("&");
  }
  return data;
};

exports.formatData = formatData;
